import { TaskCompletionRefusal } from '@jms/model';

export enum TaskCompletionDialogKind {
  OpenSubTasks = 'OpenSubTasks',
  MissingEvidence = 'MissingEvidence',
  Override = 'Override',
  CompleteWithSubTasks = 'CompleteWithSubTasks',
  SubTasksBlocked = 'SubTasksBlocked',
}

/** Only an authorised user may complete past missing evidence, and with open sub-tasks only by completing them too (WBS-12213); everyone else is told what stops them. */
export function selectTaskCompletionDialog(refusal: TaskCompletionRefusal, canOverride: boolean): TaskCompletionDialogKind {

  if (refusal.openSubTasks.length) {
    return canOverride
      ? TaskCompletionDialogKind.CompleteWithSubTasks
      : TaskCompletionDialogKind.OpenSubTasks;
  }

  return canOverride
    ? TaskCompletionDialogKind.Override
    : TaskCompletionDialogKind.MissingEvidence;
}

/** The kinds that ask the user to authorise, behind an unticked opt-in. */
export function isAuthorisingTaskCompletionDialog(kind: TaskCompletionDialogKind): boolean {

  return kind === TaskCompletionDialogKind.Override || kind === TaskCompletionDialogKind.CompleteWithSubTasks;
}
